import { useEffect, useState } from 'react'

/**
 * 値の変化を指定ミリ秒だけ遅らせて返すフック。
 *
 * 検索欄の入力ごとにリクエストが飛ぶのを防ぐ用途で使う。
 */
export const useDebouncedValue = <T>(value: T, delayMs = 300): T => {
  const [debounced, setDebounced] = useState(value)

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs)
    return () => clearTimeout(timer)
  }, [value, delayMs])

  return debounced
}
